import React from 'react';
import photo from '../../../assets/images/meFoto.jpg'
import { FlexWrapper } from '../../../components/FlexWrapper';
import { Container } from '../../../components/Container';
import { S } from './Main_Styles';
import Typewriter from 'typewriter-effect';
import Tilt from 'react-parallax-tilt';

export const Main: React.FC = () => {
    return (
        <S.Main id={"home"}>
            <Container>
                <FlexWrapper align={"center"} justify={"space-around"} wrap={"wrap"}>
                    <div>
                        <S.ForHy>Hi There</S.ForHy>
                        <S.Name>I am <span>Ainur Taganov</span></S.Name>
                        {/* <S.MainTitle>A Web Developer.</S.MainTitle> */}
                        <S.MainTitle>
                            <p>A Web Developer.</p>{/* сделали для сео, спрятали в стилях maintitle в функции добавили display:none */}
                            <Typewriter
                                options={{
                                    strings: ["A Web Developer."],
                                    autoStart: true,
                                    loop: true,
                                    delay: 150
                                }}
                            />
                        </S.MainTitle>
                    </div>
                    <Tilt
                    className="parallax-effect-img"
                    tiltMaxAngleX={40}
                    tiltMaxAngleY={40}
                    perspective={800}
                    transitionSpeed={1500}
                    scale={1.1}
                    gyroscope={true}>
                        
                        <S.PhotoWrapper>
                            <S.Photo src={photo} alt="" />
                        </S.PhotoWrapper>
                    </Tilt>
                </FlexWrapper>
            </Container>
        </S.Main>
    );
}
